
import { Link } from 'react-router-dom';

export default function Footer() {
  const tours = [
    { name: 'Evening Desert Safari', path: '/evening-desert-safari' },
    { name: 'VIP Desert Safari', path: '/vip-desert-safari' },
    { name: 'Morning Desert Safari', path: '/morning-desert-safari' },
    { name: 'Quad Bike Safari', path: '/quad-bike-safari' },
    { name: 'Premium Desert Safari', path: '/premium-desert-safari' }
  ];

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-yellow-600 mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
              Safari Deserts
            </h3>
            <p className="text-gray-300 mb-4">
              Experience the ultimate desert safari adventures in Dubai with our premium tours and authentic Bedouin experiences.
            </p>
            <div className="flex space-x-4">
              <a href="https://wa.me/971504253450" className="text-gray-300 hover:text-yellow-600 transition-colors">
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-yellow-600 transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-yellow-600 transition-colors">
                <i className="ri-facebook-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-yellow-600 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-yellow-600 transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-yellow-600 transition-colors">Contact</Link></li>
              <li><Link to="/booking" className="text-gray-300 hover:text-yellow-600 transition-colors">Book Now</Link></li>
            </ul>
          </div>

          {/* Popular Tours */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Popular Tours</h4>
            <ul className="space-y-2">
              {tours.map((tour, index) => (
                <li key={index}>
                  <Link to={tour.path} className="text-gray-300 hover:text-yellow-600 transition-colors text-sm">
                    {tour.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-phone-line text-yellow-600 mr-3"></i>
                <span className="text-gray-300">+971-50-425-3450</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-yellow-600 mr-3"></i>
                <span className="text-gray-300">dubaidesertfun@gmail.com</span>
              </div>
              <div className="flex items-start">
                <i className="ri-map-pin-line text-yellow-600 mr-3 mt-1"></i>
                <span className="text-gray-300">Dubai Desert Conservation Reserve, Dubai, UAE</span>
              </div>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Safari Deserts. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-yellow-600 text-sm transition-colors mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
